import { FaTelegram } from 'react-icons/fa6';

/**
 * ReferralSection - "Earn by Connecting" referral program section
 * Used in AllServicesPage
 */
const ReferralSection = () => {
  const steps = [
    {
      number: '01',
      title: 'You Know Someone',
      description: 'A friend, family member, or contact interested in real estate, trading, or luxury assets.'
    },
    {
      number: '02',
      title: 'Make the Intro',
      description: 'Contact me directly or send them my way. Just let them mention your name.'
    },
    {
      number: '03',
      title: 'Earn Commission',
      description: 'If the deal closes, you earn a percentage. Simple as that.'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-900 to-gray-950 border-t border-gray-800">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <p className="text-yellow-500 text-sm font-medium tracking-wider mb-3">REFERRAL PROGRAM</p>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Earn by Connecting
        </h2>
        <p className="text-lg text-gray-300 mb-3 max-w-2xl mx-auto">
          We started from zero. We know the best way forward is <span className="text-yellow-400 font-medium">collaboration</span>.
        </p>
        <p className="text-gray-400 mb-10 max-w-2xl mx-auto">
          Everyone can be a connector. This is a community where we all win together.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {steps.map((step) => (
            <div key={step.number} className="bg-gray-800/50 border border-gray-700 rounded-xl p-6">
              <div className="text-3xl font-bold text-yellow-400 mb-2">{step.number}</div>
              <h3 className="text-white font-semibold mb-2">{step.title}</h3>
              <p className="text-gray-400 text-sm">{step.description}</p>
            </div>
          ))}
        </div>
        
        <a 
          href="https://t.me/+gbLD_8i3AbIzMTY0" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-gray-900 font-bold px-8 py-4 rounded-xl transition-colors"
        >
          <FaTelegram size={20} />
          Contact Me
        </a>
      </div>
    </section>
  );
};

export default ReferralSection;
